import { render, staticRenderFns } from "./layout-category.vue?vue&type=template&id=eb9e3e7a&"
import script from "./layout-category.vue?vue&type=script&lang=js&"
export * from "./layout-category.vue?vue&type=script&lang=js&"
import style0 from "./layout-category.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports